import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";

interface DropdownMenuProps {
  menuIcon?: React.ReactNode;
  options?: { icon?: React.ReactNode; label: string; value: string }[];
  onSelect: (selected: string) => void;
  selectedValue?: string | null;
}

const ITEM_HEIGHT = 38;

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  options,
  menuIcon,
  onSelect,
  selectedValue,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value: string) => {
    onSelect(value);
    handleClose();
  };

  return (
    <Box className="sort-img">
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        {menuIcon || <MenuIcon fontSize="small" />}
      </IconButton>

      <Menu
        id="long-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        variant="menu"
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "20ch",
            },
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {options?.map((option) => (
          <MenuItem
            key={option?.value}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              borderRadius: "8px",
              margin: "4px",
              fontSize: "14px",
            }}
            value={option?.value || ""}
            onClick={() => handleSelect(option.value)}
          >
            {option?.icon || ""}
            {option?.label && (
              <Typography variant="body2">{option?.label}</Typography>
            )}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default DropdownMenu;
